<div class="favorite-list-thumb">
    <div class="wrapper">
        <div class="icon dotdotdot" (click)="onOpenMenu.emit(overview()?.id)" (clickOutside)="onCloseMenu.emit(overview()?.id)">
            <ng-content></ng-content>
        </div>
        <div class="content" (click)="onOpenFavorite.emit(overview()?.id)">
            <div class="row1">
                <div class="favorite-name" [title]="overview()?.name">{{ overview()?.name }}</div>
                @if (overview()?.hasUnitFilter) {
                    <div class="counter">{{ overview()?.numberOfUnits }}</div>
                }
            </div>
            <div class="row2">
                <!-- todo: fjernet || "-" fra pipen, må vi håndtere null på en annen måte? -->
                <span>{{ overview()?.createdTimestamp | date: "dd.MM.yyyy" }}</span>
                <span>ref #{{ overview()?.id | minLength: 6 }}</span>
            </div>
            <div class="row3">
                @if (overview()?.hasAreaFilter) {
                    <span class="mini-label">
                        <div class="icon areas"></div>
                        <div class="label">Områder</div>
                    </span>
                }
                @if (overview()?.hasUnitFilter) {
                    <span class="mini-label">
                        <div class="icon properties"></div>
                        <div class="label">Enkelteiendommer</div>
                    </span>
                }
            </div>
        </div>
        <div class="info" (click)="onOpenFavorite.emit(overview()?.id)">
            <div class="icon navigation"></div>
        </div>
    </div>
</div>
